module.exports = __webpack_public_path__ + "static/media/7.866ea5ce.png";